import axios from 'axios';
import { env } from '@/config/env';

const API_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjMsInJvbGVOYW1lIjoiYWRtaW4iLCJpYXQiOjE3ODczMDE0NjMsImV4cCI6MzMzNDQ5MDE0NjN9.apNo7RXi8HXC4qTgFNS1gwHLAi2TaH2ClmnvPml_1kk';

// Shared axios instance for the TalentChek NocoBase API. All feature API
// modules should route their `*:list/:get/:create/:update/:destroy` calls
// through this single client.
export const nocoAxios = axios.create({
  baseURL: `${env.talentchekApiBaseUrl}/api/`,
  timeout: 30_000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: `Bearer ${API_KEY}`,
  },
});